import mappings from "modules/shared/models/mappings/mappings"

export default {
  authLogin: {
    authReference: {
      environmentId: mappings.Agency.environmentId,
      subscriptionId: ""
    },
    authSession: {
      id: "",
      member: ""
    },
    authModal: {
      type: "",
      mode: ""
    }
  }
}